/** The authorization request id AuthService appends to the handoff URL: base64url, 43 characters for 32 random bytes. */
const REQUEST_ID_PATTERN = /^[A-Za-z0-9_-]{16,128}$/;

export function isValidHandoffRequestId(requestId: string | null): requestId is string {
  return requestId !== null && REQUEST_ID_PATTERN.test(requestId);
}

/**
 * The handoff target is always the configured AuthService, never a URL from the query string: the form carries the
 * user's FBO token, and a target taken from the link would let anyone who sends the link collect it.
 */
export function buildHandoffAction(authServiceApiEndpoint: string): string {
  return `${authServiceApiEndpoint.replace(/\/+$/, '')}/connect/handoff`;
}

/** What the user chose on the consent screen. The values are the ones AuthService's handoff endpoint reads. */
export type HandoffDecision = 'allow' | 'deny';

/**
 * Sends the browser to AuthService with a top-level form POST, so the token travels in the request body rather than
 * a URL and AuthService's request cookie goes with it. A denial carries no token: AuthService only needs the request
 * id to tell Claude the user cancelled.
 */
export function submitHandoffForm(
  document: Document,
  action: string,
  requestId: string,
  decision: HandoffDecision,
  fboToken?: string
): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = action;
  form.style.display = 'none';
  form.appendChild(createHiddenInput(document, 'request', requestId));
  form.appendChild(createHiddenInput(document, 'decision', decision));
  if (decision === 'allow' && fboToken) {
    form.appendChild(createHiddenInput(document, 'fbo_token', fboToken));
  }
  document.body.appendChild(form);
  form.submit();
}

function createHiddenInput(document: Document, name: string, value: string): HTMLInputElement {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = value;
  return input;
}
